































import {Component, Vue} from 'vue-property-decorator'
import CompanyInfoView from "@/view/company-manage/company/info.vue";
import companyModule from "@/store/module/CompanyModule";
import {Container} from "typescript-ioc";
import CompanyApi from "@/module/device/CompanyApi";
import {handleClipboard} from "@/util/clipboard";

@Component({
  components: {
    CompanyInfoView,
  },
})
export default class CompanyDetailView extends Vue {

  private companyApi = Container.get(CompanyApi)

  private get company() {
    return companyModule.active
  }

  private async created() {
    let id: number
    if (companyModule.activeOrNull == undefined)
      id = Number(this.$route.query.cid)
    else id = companyModule.active.id
    const company = await this.companyApi.query(id)
    await companyModule.activate(company)
  }

  private destroyed() {
    companyModule.destroy()
  }

  private copy = handleClipboard
}
